import React from 'react';
import { SalvFieldHeader, SalvTextArea } from '@salvapp/ui-components';
import { ErrorMessage, FormikHelpers } from 'formik';

export const CustomListInfoSection = ({
  editing,
  name,
  label,
  value,
  disabled,
  setFieldValue,
  className = '',
}: {
  editing: boolean;
  name: string;
  label: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  setFieldValue: FormikHelpers<unknown>['setFieldValue'];
  className?: string;
}) => {
  return (
    <div className={className}>
      {editing ? (
        <>
          <SalvTextArea
            label={label}
            value={value}
            onChange={(value) => setFieldValue(name, value)}
            disabled={disabled}
            autoSizing
            minRows={1}
          />
          <ErrorMessage name={name} render={(message) => <div className={'salv-error-message'}>{message}</div>} />
        </>
      ) : (
        <>
          <SalvFieldHeader label={label} />
          <div>{value}</div>
        </>
      )}
    </div>
  );
};

export default CustomListInfoSection;
